import * as React from 'react';

import { Container, Header, Title, Content, Text, H3, Button, Icon, Left, Right, Body, Fab, IconNB, Card, CardItem, View, Segment, Badge, ListItem, Toast } from 'native-base';
import { Platform, Dimensions, TouchableOpacity, RefreshControl, ScrollView, StyleSheet, Text as NText } from 'react-native';
import { BarChart, YAxis, XAxis, StackedBarChart, PieChart, Grid } from 'react-native-svg-charts';
import { LinearGradient, Circle, G, Line, Text as SText, Defs, Stop } from 'react-native-svg';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import * as scale from 'd3-scale';
import * as _ from 'lodash';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import PlusModal from '../../components/plusModal';
import { poundMinus } from '../../components/globals';
import TawkToButton from '../../components/tawkto';

import LatestCustomers from './latestCustomersHorizontal';
import YearsHorizontalPills from './yearsHorizontalPills';
import useScreenDimensions from '../../hooks/screenDimensions';
import HamburgerMenu from '../../components/hamburgerMenu';

import styles from './styles';
import TaxPopup from './taxPopup';
import ExpensePie from './expensePie';

class WebPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fabActive: false,
			refreshing: false,
			plusModal: false,
			taxModal: false
		};
	}

	/*PosGradient() { return (<Defs key={'gradient'}>
								<LinearGradient id={'gradient'} x1={ '0%' } y={ '0%' } x2={ '0%' } y2={ '100%' }>
									<Stop offset={ '0%' } stopColor={ '#00cc00' } stopOpacity={ 0.8 }/>
									<Stop offset={ '100%' } stopColor={ '#006622' } stopOpacity={ 1 }/>
								</LinearGradient>
							  </Defs>
	)}

	NegGradient() { return (<Defs key={'gradient'}>
								<LinearGradient id={'gradient'} x1={ '0%' } y={ '0%' } x2={ '0%' } y2={ '100%' }>
									<Stop offset={ '100%' } stopColor={ 'red' } stopOpacity={ 0.8 }/>
									<Stop offset={ '0%' } stopColor={ '#b30000' } stopOpacity={ 1 }/>
								</LinearGradient>
							</Defs>
	)}*/

	closeModal() {
		//console.log('closePlus');
		this.setState({ plusModal: false });
	}

	openModal() {
		//console.log('openModal', this.state.plusModal)
		this.setState({ plusModal: true });
	}

	render() {
		var takingData = [0]; //[ 50, 10, 40, 95, 4, 24, 85, 91, 35, 53, 53, 24 ]
		var expenseData = [0]; //   = [ -10, -40, -95, -4, -24, -85, -91, -35, -53, -53, -24, -50]
		var labels = ['']; // ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar']

		//console.log('prof', this.props.profitbymonth);

		if (!!this.props.profitbymonth && this.props.profitbymonth.length) {
			takingData = this.props.profitbymonth.map(p => Number(p.received));
			expenseData = this.props.profitbymonth.map(p => 0 - Number(p.paid));
			labels = this.props.profitbymonth.map(p => p.m.slice(0, -3));
		}

		const barData = [{ values: takingData }];
		const bar2Data = [{ values: expenseData }];
		const contentInset = { top: 20, bottom: 20, left: 20 };
		const gridMax = Math.max(...takingData);
		const gridMin = Math.min(...expenseData);

		const currYear = _.find(this.props.years, ['taxyear', this.props.currYear.toString()]);
		const profit = this.props.yearTotals ? parseInt(this.props.yearTotals.profit.replace(',', '')) : 0;

		//console.log(this.props.profitbymonth, this.props.yearTotals, 'yaxispts', [...takingData, ...expenseData]);
		//console.log('labels', labels);
		//console.log(this.props.balances);
		return (
			<Container style={styles.container}>
				<Header>
					<Left>
						<HamburgerMenu />
					</Left>

					<Body style={{ flex: 3 }}>
						<Title>Dashboard</Title>
					</Body>

					<Right>
						<TawkToButton />
						<Button transparent rounded androidRippleColor="white" onPress={() => this.openModal()}>
							<Icon active name="add" />
						</Button>
					</Right>
				</Header>

				<Content
					scrollable
					style={{ marginHorizontal: 5 }}
					refreshControl={
						<RefreshControl
							refreshing={this.props.refreshing}
							onRefresh={() => {
								this.props.doRefresh();
							}}
						/>
					}>
					<View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
						<Card style={{ margin: 10, borderTopLeftRadius: 10, borderTopRightRadius: 10, flexGrow: 1, flexShrink: 1, flexBasis: 380 }}>
							<CardItem style={{ backgroundColor: '#6aa4c8', borderTopLeftRadius: 10, borderTopRightRadius: 10, width: '100%' }}>
								<Left>
									<FontAwesome style={{ color: 'white' }} name="tachometer" />
									<Body>
										<Text style={{ color: 'white' }}>Profit & Loss</Text>
									</Body>
								</Left>
							</CardItem>

							<CardItem cardBody style={{ margin: 8, flex: 1, width: '97%' }}>
								<YearsHorizontalPills years={this.props.years} currYear={this.props.currYear} setYear={this.props.setYear} />
							</CardItem>
							<CardItem cardBody style={{ margin: 8, flex: 1 }}>
								<View style={{ flexDirection: 'row', width: '100%' }}>
									<Button
										success
										style={{ flex: 1, flexDirection: 'column', marginHorizontal: 2 }}
										onPress={() => this.props.navigation.navigate({ name: 'Report', params: { report: 'ProfitLoss', url: 'ProfitLoss', desc: 'Profit and Loss', rptFilter: 't' } })}>
										<ShimmerPlaceHolder autoRun width={40} visible={!!this.props.yearTotals} colorShimmer={['#acd87c', '#EEE', '#5cb85c']}>
											<Text style={{ fontSize: 17 }}>£{this.props.yearTotals && this.props.yearTotals.turnover}</Text>
										</ShimmerPlaceHolder>
										<Text style={{ fontSize: 10 }}>Turnover</Text>
									</Button>
									<Button
										danger
										style={{ flex: 1, flexDirection: 'column', marginHorizontal: 2 }}
										onPress={() => this.props.navigation.navigate({ name: 'Report', params: { report: 'ProfitLoss', url: 'ProfitLoss', desc: 'Profit and Loss', rptFilter: 't' } })}>
										<ShimmerPlaceHolder autoRun width={40} visible={!!this.props.yearTotals} colorShimmer={['#f9a36f', '#EEE', '#d9534f']}>
											<Text style={{ fontSize: 17 }}>- £{this.props.yearTotals && this.props.yearTotals.expenses}</Text>
										</ShimmerPlaceHolder>
										<Text style={{ fontSize: 10 }}>Expenses</Text>
									</Button>
									<Button
										info
										style={{ flex: 1.2, flexDirection: 'column', marginHorizontal: 2 }}
										onPress={() => this.props.navigation.navigate({ name: 'Report', params: { report: 'ProfitLoss', url: 'ProfitLoss', desc: 'Profit and Loss', rptFilter: 't' } })}>
										<ShimmerPlaceHolder autoRun width={40} visible={!!this.props.yearTotals} colorShimmer={['#b2d1ff', '#EEE', '#62b1f6']}>
											<Text style={{ fontSize: 17 }}>= {this.props.yearTotals && poundMinus(profit, 0, 0, 1)}</Text>
										</ShimmerPlaceHolder>
										<Text style={{ fontSize: 10 }}>{profit < 0 ? 'Loss' : 'Pre-Tax Profit'}</Text>
									</Button>
								</View>
							</CardItem>
							<CardItem cardBody style={{ flex: 1, margin: 11, flexDirection: 'row' }}>
								<TouchableOpacity
									style={{ width: '100%' }}
									onPress={() =>
										this.props.taxTotals?.isCurrent && !this.props.taxTotals?.canSubmit ? this.setState({ taxModal: true }) : this.props.navigation.navigate('SaDetails', { year: this.props.currYear })
									}>
									<ShimmerPlaceHolder autoRun width={300} visible={!!this.props.taxTotals}>
										<View style={{ flexDirection: 'row' }}>
											<Text style={{ flex: 3 }}>{this.props.taxTotals && this.props.taxTotals.text}</Text>
											<Text style={{ textAlign: 'right', flex: 1, paddingHorizontal: 15 }}>£{this.props.taxTotals && this.props.taxTotals.val}</Text>
											<Icon name={this.props.taxTotals?.isCurrent ? 'open' : 'arrow-forward'} style={{ color: 'grey', fontSize: 16, marginLeft: 2, marginTop: 3 }} />
										</View>
									</ShimmerPlaceHolder>
								</TouchableOpacity>
							</CardItem>
						</Card>

						<Card style={{ margin: 10, borderTopLeftRadius: 10, borderTopRightRadius: 10, flexGrow: 1, flexShrink: 1, flexBasis: 380 }}>
							<CardItem style={{ backgroundColor: '#6aa4c8', borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
								<Left>
									<FontAwesome style={{ color: 'white' }} name="money" />
									<Body>
										<Text style={{ color: 'white' }}>Cash Flow</Text>
									</Body>
								</Left>
							</CardItem>
							<CardItem style={{ flexBasis: 250, flexDirection: 'column' }}>
								{!!this.props.profitbymonth && gridMax == 0 && gridMin == 0 ? (
									<View style={{ flex: 1, flexDirection: 'row' }}>
										<Text>To add transactions, press the + at the top or go to the People or Daily Entries screens</Text>
									</View>
								) : (
									<View style={{ flex: 1, height: 200, width: '100%', flexDirection: 'row', paddingBottom: 15 }}>
										<YAxis
											data={[...takingData, ...expenseData]}
											//yAccessor={({ item }) => item.count}
											style={{ width: 35, height: '100%' }}
											svg={{
												fill: 'grey',
												fontSize: 10
											}}
											//contentInset={{ bottom:5,top:-5 }}
											formatLabel={value => (value >= 0 ? `£${value}` : `- £${0 - value}`)}
										/>
										<View style={{ flex: 1, height: '100%', flexDirection: 'column' }}>
											<BarChart
												style={{ width: '100%', position: 'absolute', height: '100%' }}
												data={takingData}
												gridMax={gridMax}
												gridMin={gridMin}
												showGrid={true}
												svg={{
													strokeWidth: 2,
													fill: 'url(#gradientgrn)'
												}}
												//contentInset={ contentInset }
											>
												<Defs key={'gradientgrn'}>
													<LinearGradient id={'gradientgrn'} x1={'0%'} y={'0%'} x2={'0%'} y2={'100%'}>
														<Stop offset={'0%'} stopColor={'#00cc00'} stopOpacity={0.8} />
														<Stop offset={'100%'} stopColor={'#006622'} stopOpacity={1} />
													</LinearGradient>
												</Defs>
												<Grid />
											</BarChart>
											<BarChart
												style={{ width: '100%', position: 'absolute', height: '100%' }}
												data={expenseData}
												gridMax={gridMax}
												gridMin={gridMin}
												showGrid={false}
												svg={{
													strokeWidth: 2,
													fill: 'url(#gradientred)'
												}}
												//contentInset={ contentInset }
											>
												<Defs key={'gradientred'}>
													<LinearGradient id={'gradientred'} x1={'0%'} y={'0%'} x2={'0%'} y2={'100%'}>
														<Stop offset={'100%'} stopColor={'red'} stopOpacity={0.8} />
														<Stop offset={'0%'} stopColor={'#b30000'} stopOpacity={1} />
													</LinearGradient>
												</Defs>
											</BarChart>
											<XAxis
												data={takingData}
												svg={{
													fill: 'grey',
													fontSize: 8,
													fontWeight: 'bold',
													rotation: 12,
													originY: 30,
													y: 5,
													x: -5
												}}
												formatLabel={(_, index) => labels[index]}
												style={{ height: 15, position: 'absolute', width: '100%', bottom: -15 }}
												scale={scale.scaleBand}
											/>
										</View>
									</View>
								)}
							</CardItem>
						</Card>

						<Card style={{ margin: 10, borderTopLeftRadius: 10, borderTopRightRadius: 10, flexGrow: 1, flexShrink: 1, flexBasis: '100%' }}>
							<View style={{ flexDirection: 'column', width: '100%', flex: 1 }}>
								<CardItem style={{ backgroundColor: '#6aa4c8', borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
									<Left>
										<FontAwesome style={{ color: 'white' }} name="user" />
										<Body>
											<Text style={{ color: 'white' }}>Latest Customers</Text>
										</Body>
									</Left>
								</CardItem>

								<LatestCustomers customers={this.props.customers} navigation={this.props.navigation} />
							</View>
						</Card>

						<Card style={{ margin: 10, borderTopLeftRadius: 10, borderTopRightRadius: 10, flexGrow: 1, flexShrink: 1, flexBasis: 380 }}>
							<CardItem style={{ backgroundColor: '#6aa4c8', borderTopLeftRadius: 10, borderTopRightRadius: 10, width: '100%' }}>
								<Left>
									<FontAwesome style={{ color: 'white' }} name="credit-card" />
									<Body>
										<Text style={{ color: 'white' }}>Expense Types {currYear && currYear.text}</Text>
									</Body>
								</Left>
							</CardItem>

							<CardItem style={{ height: 200, flex: 1, flexBasis: 200 }}>
								{this.props.yearTotals?.expenseCats ? <ExpensePie pdata={this.props.yearTotals.expenseCats} yearText={currYear.text} /> : <Text>No expenses yet this year</Text>}
							</CardItem>
						</Card>

						<Card style={{ margin: 10, paddingBottom: 10, borderTopLeftRadius: 10, borderTopRightRadius: 10, flexGrow: 1, flexShrink: 1, flexBasis: 380 }}>
							<CardItem style={{ backgroundColor: '#6aa4c8', borderTopLeftRadius: 10, borderTopRightRadius: 10, width: '100%' }}>
								<Left>
									<FontAwesome style={{ color: 'white' }} name="credit-card" />
									<Body>
										<Text style={{ color: 'white' }}>Balances</Text>
									</Body>
								</Left>
							</CardItem>

							{this.props.balances &&
								this.props.balances.map(
									(l, i) =>
										l && (
											<CardItem key={i}>
												<Text style={{ margin: 0, flex: 1, fontWeight: i == this.props.balances.length - 1 ? 'bold' : 'normal' }}>{l.label}</Text>

												<Text style={{ textAlign: 'right', fontWeight: i == this.props.balances.length - 1 ? 'bold' : 'normal' }}>£ {l.value.toFixed(2)}</Text>
											</CardItem>
										)
								)}
						</Card>
					</View>
				</Content>

				<PlusModal visible={this.state.plusModal} closeModal={() => this.closeModal()} navigation={this.props.navigation} />
				<TaxPopup visible={this.state.taxModal} closeModal={() => this.setState({ taxModal: false })} calc={this.props.taxTotals?.calc} />
			</Container>
		);
	}
}

export default WebPage;
